import type { THttpClientSSRInstance } from '@alfa-bank/site-data-fetch-helpers/src/models';
import type { TOptions, TParams } from '@alfa-bank/site-http-client/src/models';
import { httpClient } from '@alfa-bank/site-http-client';

import type { IGraphQLResponse } from './models';

export interface IFetchGQLArgs<Params> {
    /** Конфиг для httpClient */
    config?: TOptions;
    /** URL для запроса */
    endpointUrl: string;
    /** Текст ошибки, если сервис не отвечает */
    fetchErrorText: string;
    /** Экземпляр httpClient для работы с кондуктором. По дефолту - обычный axios. */
    httpClientInstance?: THttpClientSSRInstance;
    /** Параметры передаваемые в запрос */
    requestParams: Params;
}

/** Клиент для работы с сервисами, построенными на GraphQL */
export const fetchGQL = async <Response, Params extends TParams = TParams>({
    requestParams,
    config,
    httpClientInstance = httpClient,
    endpointUrl,
    fetchErrorText,
}: IFetchGQLArgs<Params>) => {
    const { data: response } = await httpClientInstance.post<IGraphQLResponse<Response>>(
        endpointUrl,
        requestParams,
        config
    );

    if (!response.errors && response.data) {
        return { data: response.data };
    }

    console.error(response.errors);
    throw new Error(fetchErrorText);
};
